<template>
<div id="login">

<div class="header">
  <img src="../../assets/weibind.png" />
  <div class="header-w"></div>
</div>

<template v-if=" binded!== undefined">

  <div v-if="!binded" class="s-title">获取授权</div>
  <div v-if="!binded" class="s-tips">请在下方输入学堂账号信息，授权公众号为您及时推送考试发布通知</div>


  <div v-if="binded" class="s-title">已授权</div>
  <div v-if="binded" class="s-tips">您已授权，有考试发布我们将第一时间推送给您</div>

</template>

<!-- 未授权 -->
  <template  v-if=" binded!== undefined && !binded">

      <div class="s-input-c phone">
        <input class="s-input" v-model="phoneValue" type="number" oninput="if(value.length > 11)value = value.slice(0, 11)" @blur="verification()" 
        placeholder="手机号" maxlength="11" />

      </div>

      <div class="s-input-c yzm" v-if="vercodelogin">
        <!-- <div class="">验证码</div> -->
        <input class="s-input" v-model="vercodeValue" type="number" placeholder="验证码" maxlength="11" />
        
        <div class="yzmbtn" v-if="vercodelogin" @click="getvercode" v-track="{ name: 'getvercode' }">{{yzmTxt}}</div>

      </div>


      <div class="s-input-c yzm" v-if="!vercodelogin">
        <!-- <div class="">验证码</div> -->
        <input class="s-input" v-model="passwordValue" type="password" placeholder="请输入密码" />
      </div>

      <div  v-if="!binded" class="handle">
        <div class="zc"></div>
        <div class="logintype" @click="vercodelogin = !vercodelogin" v-track="{ name: 'changeloginstate' }">
          {{vercodelogin?"账号密码授权":"验证码收取"}}</div>
      </div>

  </template>

<!-- 已授权 -->
  <template  v-if=" buserinfo && binded!== undefined &&  binded">
    <div class="binded">
        <div class="binded-t">授权账号 
          <span class="binded-tx">{{phone}}</span>
        </div>
        <div  @click="cancelbind()" class="cancelBind">取消授权</div>
    </div>

    <div class="binded">
        <div class="binded-t">
          <span>学生姓名</span>
           <span class="binded-tx" v-if="buserinfo.schoolGuid">{{buserinfo.studentName}}</span>
           <span class="binded-tx binded-tx2 " v-if="!buserinfo.schoolGuid">该账号还未绑定学生信息，可前往七天学堂APP绑定。</span>

        </div>
    </div>

  </template>


  <div v-if=" binded!== undefined && !binded" class="sfinish" 
    :class="{'selected': phoneValue && (passwordValue || vercodeValue)} "
    @click="login()"  v-track="{ name: 'login' }">
    <span v-if="!loading">立即授权</span>
    <van-loading v-if="loading" color="#fff" size="18" class="loading" type="spinner" />

  </div>

</div>
</template>

<script>
import Toast from 'vant/lib/toast';
import "vant/lib/toast/style";
import Loading from 'vant/lib/loading';
import "vant/lib/loading/style";
import Dialog from "vant/lib/dialog";
import "vant/lib/dialog/style";
import { host }  from "@/common/common.js"

import {
  api_sendSms,
  api_loginSms,
  api_loginPwd,
  api_userInfo,
  api_cancelBind,
  api_isWXBind,
} from "@/api"

export default {
  name: 'Sign',
  data() {
    return {
      phoneValue: null,
      vercodeValue: null,
      passwordValue: null,
      yzmTxt: "获取验证码",
      time: 60,
      vercodeToken: null,
      agree: false,
      vercodelogin: true,
      loading: false,
      showpro:true,
      binded:false,
    }
  },
  methods: {

    getvercode() {
      if (!this.phoneReg(this.phoneValue)) {
        Toast({
          message: "请输入正确手机号",
          duration: 2000
        })
        return;
      }
      Toast({
        message: "验证码已发送",
        duration: 1000
      })
      this.startCountingDown();
      this.$track('click_login_sendsms')
      api_sendSms(this.phoneValue).then(res => {
        console.log("api_sendSms", res);
        this.vercodeToken = res.data.token;
      }).catch(error => console.log(error));

    },
    phoneReg(phone) {
      return /^1[0-9][0-9]\d{8}$/.test(phone)
    },
    loginchange() {
      this.agree = !this.agree;
      this.vercodeValue = null;
      this.passwordValue = null;
    },
    login() {

      if (this.loading) {
        return;
      }

      if (!this.phoneReg(this.phoneValue)) {
        Toast({
          message: "请输入正确手机号",
          duration: 2000
        })
        return;
      }

      if (!this.vercodeToken && this.vercodelogin) {
        Toast({
          message: "请获取验证码",
          duration: 2000
        })
        return;
      }

      if (!this.vercodeValue && this.vercodelogin) {
        Toast({
          message: "请输入验证码",
          duration: 2000
        })
        return;
      }

      if (!this.passwordValue && !this.vercodelogin) {
        Toast({
          message: "请输入密码",
          duration: 2000
        })
        return;
      }

  /*
      if(!this.$store.state.openid){
        Toast({
          message: "请在微信环境内服务该网页",
          duration: 2000
        })
        return;
      }
    */

      this.loading = true;

      if (this.vercodelogin) {
        this.$track('2022_click_login_sms')
        //验证码登录
        api_loginSms(this.phoneValue,
          this.vercodeValue,
          this.vercodeToken,
          this.$store.state.openid).then(res => {
          this.$store.commit('cmtToken', res.data.token);
          // this.goBack()
          this.userinfo(res.data.token);
          this.loading = false;
        }).catch(ex => {
          console.log('api_loginSms ex', ex);
          this.loading = false;
        });
      } else {
        //密码登录
        this.$track('2022_click_login_password')
        api_loginPwd(this.phoneValue,
          this.passwordValue,
          this.$store.state.openid).then(res => {
          this.$store.commit('cmtToken', res.data.token);
          // this.goBack()
          this.userinfo(res.data.token);
          this.loading = false;
        }).catch(ex => {
          console.log('api_loginPwd ex', ex);
          this.loading = false;
        });
      }
    },

    userinfo(token){
        api_userInfo(token).then(res=>{
          // this.buserinfo = res.data;
          this.$store.commit('cmtUserInfo', res.data);
           
        }).catch(ex=>{
          console.log("api_userInfo ex ",ex);

        })
    },

    cancelbind(){

        Dialog.confirm({
          title:"确定要取消授权？",
          message:"取消后，将无法收到考试通知哦",
          cancelButtonText:'取消',
          confirmButtonText:'确定',
          confirmButtonColor:'#EE3F4D'
        }).then(()=>{
            console.log("确认")

             api_cancelBind({
              userGuid:this.$store.state.userInfo.userGuid,
              type:1
            }).then(res=>{
                this.binded = false;
                Toast({
                  message: "取消授权成功",
                  duration: 2000
                })
                console.log("cancelbind res ",res);
            }).catch(ex=>{
                console.log("cancelbind ex ",ex);
            }).final(()=>{
              
            })

        }).catch(()=>{
            console.log("取消")

        })

       
    },

    verification() {
      var re = /^1\d{10}$/;
      let str = this.phoneValue;
      if (re.test(str)) {
        console.log(str);
      } else {
        console.log(str);
      }
    },
    startCountingDown() {
      this.time -= 1
      if (this.time <= 0) {
        this.yzmTxt = '获取验证码'
        this.time = 60
      } else {
        this.yzmTxt = this.time + ' s'
        setTimeout(() => {
          this.startCountingDown()
        }, 1000);
      }
    },
    goBack() {
      let query = this.$route.query

      if (query.from) {
        let path = query.from
        delete query.from
        this.$router.replace({
          path: decodeURIComponent(path),
          query: query
        })
      } else {
        this.$router.back()
      }
    }
  },
  computed:{
    buserinfo(){

      if(this.$store.state.userInfo ){
        /*
          if(!this.$store.state.userInfo.userCode){
              this.binded = false;
              Toast({
                    message: "该账号未注册，请先前往学堂APP注册",
                    duration: 3000
                })
          }else{
            
          }
        */

        api_isWXBind().then(res=>{
             this.binded = res.data.isWXBind;
          }).catch(ex=>{
              console.log("api_isWXBind ex",ex);
               this.binded = false;
          })
      }
    
      return this.$store.state.userInfo ? this.$store.state.userInfo:null;
    },
    phone(){
          if(this.$store.state.userInfo.userCode){
             return this.$store.state.userInfo.userCode.slice(0,3) + "****" +  this.$store.state.userInfo.userCode.slice(-4);

          }else{
              return ""
          }
    }
  },
  components: {
    'van-loading': Loading,
  },
  mounted() {
      var h = document.body.scrollHeight;
      window.onresize = ()=>{
         if (document.body.scrollHeight < h) {
           this.showpro = false;
        }else{
             this.showpro = true;
       }
      }
  },
  created() {
    this.$track('start_login')
    // this.$store.dispatch("act_logout","");

    this.$store.dispatch('share/initShareParams', {
      title: '七天学堂学情查询',
      desc: '快来看看你的学情分析报告'
    })
  }
}
</script>

<style lang="scss">
#login {
    // padding-left: 26px;
    // padding-right: 26px;

 

    .header{
      width: 100%;
      height: 140px;
      background: #F3F4F7;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      img{
            width: 160px;
            position: absolute;
            z-index: 100;
            right: 10px;
            top: 15px;
      }
    }
    .header-w{
      position: absolute;
      background: #fff;
      width: 2000px;
      height: 2000px;
      border-radius: 2000px;
      transform: translate(-50%,45px);
    }

    .s-title {
        font-size: 28px;
        margin-bottom: 2px;
        margin-left: 20px;
        margin-top: 15px;
    }

    .sub-title {
        font-size: 15px;
        color: #c5c6c7;
        margin-top: 22px;
    }

  input::-webkit-input-placeholder { 
    /* WebKit browsers */ 
    color: #999 !important; 
    font-size: 14px;
    font-weight: bold !important;
    } 

    .s-tips{
      font-size: 14px;
      margin-left: 20px;
      color: #999;
      width: 55%;
      margin-bottom: 26px;
    }

    .s-input {
        border: none;
        font-size: 17px;
        color: #999;

    }

    .s-input::-webkit-input-placeholder {
        color: #c5c6c7;
    }

    .binded-t{
        display: flex;
      flex-direction: row;
    }

    .binded-tx{
      margin-left: 10px;
      width: 60%;
    
    }
    
    .binded-tx2{
      color: #999;
      font-size: 13px;
    }


    .binded{
          margin-left: 20px;
          margin-right: 20px;
          padding-bottom: 10px;
          margin-bottom: 25px;
          font-size: 14px;
          position: relative;
    }

     .binded::before{
        height: 0.55px;
        content: "";
        width: 100%;
        background: #dadada !important;
        position: absolute;
        right: 0;
        -webkit-transform: scaleY(0.35);
        -ms-transform: scaleY(0.35);
        transform: scaleY(0.35);
        z-index: 99;
        bottom:0px;
    }

    .cancelBind{
      position: absolute;
      right: 18px;
      color: #EE3F4D;
      top:0px;
    }



    .s-input-c {
        margin-left: 20px; 
        margin-right: 20px;
        box-sizing: border-box;
        padding-top: 10px;
        padding-bottom: 15px;
        position: relative;
    }

    .s-input-c::after {
        height: 0.55px;
        content: "";
        width: 100%;
        background: #dadada !important;
        position: absolute;
        right: 0;
        -webkit-transform: scaleY(0.35);
        -ms-transform: scaleY(0.35);
        transform: scaleY(0.35);
        z-index: 99;
        bottom: 0;
    }

    .phone {
        margin-bottom: 25px;
    }

    .yzmbtn {
        position: absolute;
        right: 0;
        top: 11px;
        color: #EE3F4D;
        font-size: 14px;
        border: 1px solid #EE3F4D;
        border-radius: 5px;
        padding: 2px 10px;
    }

    .handle {
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        font-size: 12px;
        margin-left: 20px;
        margin-right: 20px;
        color: #999;
        .zc {
            width: 80px;
            height: 25px;
        }

        .logintype {
            width: 80px;
            height: 25px;
            text-align: right;
        }
    }

    .yzm {
        display: flex;
        // justify-content: space-between;
        font-size: 17px;
        margin-top: 15px;

        .s-input {
            //  margin-left: 15px;

        }
    }

 .selected{
    background: #ed5b68 !important;
  }

    .sfinish {
        color: white;
        background: #F09FA6;
        margin-left: 20px;
        margin-right: 20px;
        height: 50px;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
         box-shadow: 0px 4px 4px #ee3f4d40;
        margin-top: 30px;
        // margin-left: 5%;
    }

    .c-xieyi {
        position: absolute;
        bottom: 10px;
        display: flex;
        align-items: center;
        font-size: 13px;
        margin-top: 10px;
        color: #c5c6c7;
        .select {
            width: 14px;
            height: 14px;
            border-radius: 14px;
            border: 1px solid #c5c6c7;
            margin-right: 5px;
        }

        .agree {
            border: 1px solid #ed5b68;
            background: #ed5b68;
        }

        span {
            color: #5C94E4;
        }
    }

}
</style>
